import React from 'react';
import { useDocumentVersionsQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import DiscourseHistoryItem, {
	DiscourseBaseItem,
	DiscourseItem,
} from '../DiscourseHistory/DiscourseHistoryItem';
import styles from './DiscourseItemVersionHistory.module.scss';
import Text from '../../../../Components/Base/Text/Text';

interface Props extends DiscourseBaseItem {
	discourseId: string;
}

const DiscourseItemVersionHistory: React.FC<Props> = ({
	discourseId,
	patientId,
	virtualPatientId,
	openCareClaimModal,
	reloadData,
}) => {
	const { data, isLoading } = useDocumentVersionsQuery({
		where: { id: discourseId },
	});

	const documentVersions = data?.documentVersions?.data || [];

	if (isLoading) {
		return <Loading />;
	}

	if (documentVersions.length < 1) {
		return (
			<div className={styles.wrapper}>
				<Text tx='component.discourseItemVersionHistory.noDataMessage' />
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			{documentVersions?.map(version => {
				return (
					<DiscourseHistoryItem
						item={version as DiscourseItem}
						key={version.id}
						patientId={patientId}
						virtualPatientId={virtualPatientId}
						openCareClaimModal={openCareClaimModal}
						reloadData={reloadData}
						allowMedicalProcedures={false}
					/>
				);
			})}
		</div>
	);
};

export default DiscourseItemVersionHistory;
